import { render, staticRenderFns } from "./ApplicantProfileRequirements.vue?vue&type=template&id=064d1995"
import script from "./ApplicantProfileRequirements.vue?vue&type=script&lang=js"
export * from "./ApplicantProfileRequirements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports